import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { useNavigate } from 'react-router-dom'
import { Container, Typography, Button } from '@mui/material'
import { Add } from '@mui/icons-material'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'
import { useFlightDeck } from 'src/context/FlightDeckContext'

const QuestionPoolList = React.lazy(() => loadComponent('mfeedback', 'QuestionPoolList'))

const StyledButton = styled(Button)`
    float: right;
`
const StyledHeadingText = styled(Typography)`
    margin-bottom: ${({ theme }) => theme.spacing(3)};
    float: left;
`

const StyledHeaderContainer = styled(Container)`
    height: 4vh;
`

export function QuestionPoolIndexRoute() {
    const navigate = useNavigate()
    const { academy } = useFlightDeck()
    const canCreate = usePermission('feedback.questionPool.create', {})
    const canDelete = usePermission('feedback.questionPool.delete', {})

    const onSelect = useCallback(
        (questionPoolId: string) => {
            navigate(questionPoolId + '/update')
        },
        [navigate],
    )

    const onCreate = useCallback(() => {
        navigate('/marah-feedback/question_pools/new')
    }, [navigate])

    const onDelete = () => {
        navigate('/marah-feedback/question_pools')
    }

    return (
        <RouteContainer>
            <StyledHeaderContainer disableGutters>
                <StyledHeadingText variant="h4">Fragenpools</StyledHeadingText>
                {canCreate && (
                    <StyledButton variant="contained" color="primary" onClick={() => onCreate?.()} startIcon={<Add />}>
                        neu
                    </StyledButton>
                )}
            </StyledHeaderContainer>
            <QuestionPoolList academyId={academy?._id} canDelete={canDelete} onDelete={onDelete} onSelect={onSelect} />
        </RouteContainer>
    )
}
